import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Card, Tag, Input, Button, Modal } from "antd";
import {
  req_list_pim_define_day_self,
  req_del_pim_define_day,
} from "../../api";
import { getDateYYYYMM } from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
import StandardTimeStaffAddModal from "./standard-time-staff-add-modal";
import StandardTimeStaffImportModal from "./standard-time-staff-import-modal";

class StandardTimeStaff extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: window.innerWidth,
    nowYearMonth: getDateYYYYMM(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    data: [],
    item: {},
    isShowAddModal: false,
    isShowImportModal: false,
    isUploadModal: false,
  };

  UNSAFE_componentWillMount() {
    window.removeEventListener("resize", this.resize.bind(this));
    this.init_columns();
  }
  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_item_list();
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_item_list = async () => {
    const { nowYearMonth, searchField, searchValue } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true, data: [] });
    const result = await req_list_pim_define_day_self(
      userLevel,
      userCode,
      nowYearMonth,
      searchField,
      searchValue,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items, loading: false });
      // console.log(items);
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_del_pim_define_day(key, token);

    if (result.status === "success") {
      this.handle_data_refresh();
    } else {
    }
  };

  // 樣式設定 //////////////////////////////////////////////
  statusWorkDescription = (Status) => {
    switch (Status) {
      case "PASS":
        return "停班";
      case "WORK":
        return "上班";
      default:
        return "待定";
    }
  };

  style_switch_color_tag(column, param) {
    switch (column) {
      case "REASON":
        switch (param) {
          case "工作日":
          case "補班日":
            return "blue";
          case "休息日":
            return "green";
          case "例假日":
          case "國定假日":
          case "停班停課":
          case "補休日":
            return "red";
          case "休假日":
            return "gold";
          case "平假日調換":
            return "purple";
          case "工作日調移":
            return "Tan";
          default:
            return "default";
        }
      case "TYPE_APPLY":
        switch (param) {
          case "補簽到退申請":
            return "blue";
          case "工作日加班申請":
            return "orange";
          case "休息日加班申請":
            return "red";
          case "平假日調換申請":
            return "purple";
          case "工作日調移申請":
            return "Tan";
          default:
            return "default";
        }
      case "WEEK":
        switch (param) {
          case "週一":
          case "週二":
          case "週三":
          case "週四":
          case "週五":
            return "blue";
          case "週六":
            return "green";
          case "週日":
            return "red";
          default:
            return "default";
        }
      case "STATUS_WORK":
        switch (param) {
          case "PASS":
            return "red";
          case "WORK":
            return "blue";
          default:
            return "blue";
        }
      case "STATUS_APPLY":
        switch (param) {
          case "APPLY":
            return "blue";
          case "AY":
            return "blue";
          case "BY":
            return "blue";
          case "CY":
            return "blue";
          case "DY":
            return "blue";
          case "EY":
            return "blue";
          case "ALLAGREE":
            return "green";
          case "AN":
            return "red";
          case "BN":
            return "red";
          case "CN":
            return "red";
          case "DN":
            return "red";
          case "EN":
            return "red";
          case "ZN":
            return "red";
          default:
            return "blue";
        }
      case "STATUS_CONFIRM":
        switch (param) {
          case "NO":
            return "red";
          case "YES":
            return "green";
          default:
            return "default";
        }
      default:
        return "blue";
    }
  }

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_item_list();
  };

  handle_btn_del = (item) => {
    const { Uid } = item;
    Modal.confirm({
      title: `您確定刪除此筆資料嗎?`,
      onOk: () => {
        this.api_delete_item(Uid);
      },
    });
  };

  handle_btn_add_single = () => {
    this.setState({ isShowAddModal: true });
  };
  handle_btn_add_multiple = () => {
    this.setState({ isUploadModal: true });
  };

  // 欄位設定 /////////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "操作",
        width: "50px",
        align: "center",
        fixed: "true",
        render: (item) => {
          return (
            <>
              {" "}
              <button
                className="btn btn-danger btn-sm"
                onClick={() => this.handle_btn_del(item)}
              >
                <i className="fas fa-calendar-times"></i> 刪除
              </button>
            </>
          );
        },
      },
      {
        title: "日期分類",
        dataIndex: "DefineReason",
        key: "DefineReason",
        align: "center",
        width: 100,
        render: (text) => (
          <>
            <Tag color={this.style_switch_color_tag("REASON", text)}>
              {text}
            </Tag>
          </>
        ),
      },
      {
        title: "作息狀態",
        dataIndex: "DefineStatus",
        key: "DefineStatus",
        align: "center",
        width: 100,
        render: (text) => (
          <>
            <Tag color={this.style_switch_color_tag("STATUS_WORK", text)}>
              {this.statusWorkDescription(text)}
            </Tag>
          </>
        ),
      },
      {
        title: "自訂日期",
        align: "center",
        width: 100,
        render: (item) => (
          <span
            style={{
              color: this.style_switch_color_tag("WEEK", item.WeekdayName),
            }}
          >
            {item.DefineDate} {item.WeekdayName}
          </span>
        ),
      },
      {
        title: "起始時間",
        dataIndex: "DefineBunchIn",
        key: "DefineBunchIn",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "結束時間",
        dataIndex: "DefineBunchOut",
        key: "DefineBunchOut",
        align: "center",
        width: 100,
        render: (text) => <>{text}</>,
      },
      {
        title: "原因說明",
        dataIndex: "RecordDescription",
        key: "RecordDescription",
        width: 100,
        render: (text) => <>{text}</>,
      },
    ];
  };

  ///////////////////////////////////////////////////////////
  render() {
    const { data, loading, nowYearMonth, isShowAddModal, isUploadModal } =
      this.state;
    const title = (
      <div>
        <Input
          placeholder="年月"
          style={{ width: 100, margin: "0 5px" }}
          value={nowYearMonth}
          onChange={(event) =>
            this.setState({ nowYearMonth: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_item_list()}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_data_refresh()}>
          <i className="fas fa-sync-alt"></i>
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_btn_add_single()}>
          <i className="fas fa-calendar-plus"></i>
          <span style={{ marginLeft: "4px" }}>單筆新增</span>
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_btn_add_multiple()}>
          <i className="fas fa-file-import"></i>
          <span style={{ marginLeft: "4px" }}>多筆匯入</span>
        </Button>{" "}
      </div>
    );
    return (
      <Card>
        {title}
        <Table
          bordered
          rowKey="Uid"
          columns={this.columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <Modal
          destroyOnClose={true}
          visible={isShowAddModal}
          width={350}
          onOk={() => {
            this.setState({ isShowAddModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowAddModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <StandardTimeStaffAddModal />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isUploadModal}
          width={300}
          onOk={() => {
            this.setState({ isUploadModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isUploadModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <StandardTimeStaffImportModal
            item={this.props.location.state}
            creator={this.props.user}
          />
        </Modal>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(StandardTimeStaff);
